
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { DocumentSummary } from "../../../domain/document";

@Component
export default class RestrictedDocumentHandleableMixin extends Mixins() {
  @Prop()
  isReadRestrictionAlreadyHandled: boolean;
  
  async isReadConfirmedDocument(patientNo: string, documentId: number, cancelButtonText: string): Promise<boolean> {
    if (this.isReadRestrictionAlreadyHandled) { return true; }
    if (!patientNo) { throw new Error("patientNo is empty!!!"); }
    if (!documentId) { throw new Error("documentId is empty!!!"); }
    const repo = DomainRegistry.document.getDocumentRepository();
    const summary = await repo.getDocumentSummary(patientNo, documentId);
    try {
      await this.executeReadableValidate(summary, cancelButtonText);
      await this.executeReadingConfirm(summary, cancelButtonText);
      await this.executeReadingAuthenticate(summary);
      await this.executeReadingHistoryRegister(summary);
      return true;
    } catch (e) {
      return false;
    }
  }

  private async executeReadableValidate(summary: DocumentSummary, cancelButtonText: string): Promise<void> {
    if (summary.isReadable) { return; }
    await this.$commonDialogs.confirmation.show({
      title: null, 
      message: ["この書類の閲覧は許可されていません。"],
      buttons: [],
      cancellation: {
        isEnable: true,
        label: cancelButtonText,
      },
    });
    throw new Error("この書類の閲覧は許可されていません。");
  }

  private async executeReadingConfirm(summary: DocumentSummary, cancelButtonText: string): Promise<void> {
    if (!summary.shouldConfirmReadable) { return; }
    const index = await this.$commonDialogs.confirmation.show({
      title: null, 
      message: summary.shouldWriteAuditLog
        ? ["この書類の閲覧は許可されていません。閲覧履歴は管理者に通知されます。", "処理を続行しますか？"]
        : ["この書類の閲覧は許可されていません。処理を続行しますか？"],
      buttons: [
        {
          kind: "danger",
          label: "続行する",
        }, 
      ],
      cancellation: {
        isEnable: true,
        label: cancelButtonText,
      },
    });
    if (index !== 0) { throw new Error("閲覧がキャンセルされました。"); }
  }
  
  private async executeReadingAuthenticate(summary: DocumentSummary): Promise<void> {
    if (!summary.shouldLogin) { return; }
    await this.$commonDialogs.authentication.authenticator.show();
  }

  private async executeReadingHistoryRegister(summary: DocumentSummary): Promise<void> {
    if (!summary.shouldWriteAuditLog) { return; }
    try {
      const repo = DomainRegistry.document.getDocumentRepository();
      await repo.registerAuditLog(summary);
    } catch (e) {
      this.$error(
        "閲覧履歴通知失敗",
        "閲覧履歴通知でエラーが発生しました。",
        e,
      );
      throw e;
    }
  }
}
